/**
 * Every route pattern in the app, for Sentry's `reactRouterV5Instrumentation`.
 *
 * Sentry names a page-load transaction after the pattern a URL matches. Any URL
 * that matches nothing is named after the raw path instead — so `/jobs/12345`
 * and `/jobs/12346` become two separate transactions, and a busy page scatters
 * into thousands of one-hit entries that never surface as slow.
 *
 * This list previously lived inline in `src/index.tsx` and had drifted to cover
 * only 32 of the app's patterns; `/jobs`, `/jobs/:jobId`, `/dashboard` and 20
 * others were invisible in performance data. `routePatterns.test.ts` now fails
 * if a route is added to the router without being registered here.
 *
 * ORDER MATTERS. `matchPath` is prefix-based unless `exact` is set, so `/jobs`
 * would swallow `/jobs/:jobId` if it came first. Entries are sorted
 * most-specific-first, with the `/` catch-all last. Keep it that way.
 */
export const SENTRY_ROUTE_PATTERNS: { path: string }[] = [
  { path: '/interviews/:interviewId/:assistantMode(prep|live|coach)?' },
  { path: '/interviews/:interviewId/mark-interview-status' },
  { path: '/career-portal/themes/:themeId' },
  { path: '/templates/:templateId/clone' },
  { path: '/templates/:templateId/edit' },
  { path: '/ask-kula/c/:sessionId' },
  { path: '/conversational-analytics/:chatId' },
  { path: '/notifications/recent-activities' },
  { path: '/dashboard/pending-activities' },
  { path: '/internal-job-board/:jobId' },
  { path: '/reports/team-productivity' },
  { path: '/blueprints/:blueprintId' },
  { path: '/candidates/:contactId' },
  { path: '/csv-exports/:exportId' },
  { path: '/interviews/upcoming' },
  { path: '/projects/:projectId' },
  { path: '/reports/flow-health' },
  { path: '/scorecards/generate' },
  { path: '/circles/:companyId' },
  { path: '/flows/:outreachId' },
  { path: '/reports/:reportID' },
  { path: '/reports/diversity' },
  { path: '/projects/reviews' },
  { path: '/reports/generate' },
  { path: '/interviews/past' },
  { path: '/interviews/all' },
  { path: '/intro/addemail' },
  { path: '/intro/consent' },
  { path: '/templates/new' },
  { path: '/jobs/:jobId' },
  { path: '/reports/ats' },
  { path: '/reports/kpi' },
  { path: '/internal-job-board' },
  { path: '/password_reset' },
  { path: '/career-portal' },
  { path: '/design-system' },
  { path: '/reports-home' },
  { path: '/requisitions' },
  { path: '/settings' },
  { path: '/unsubscribed' },
  { path: '/unsubscribe' },
  { path: '/candidates' },
  { path: '/interviews' },
  { path: '/ats_table' },
  { path: '/dashboard' },
  { path: '/referrals' },
  { path: '/templates' },
  { path: '/projects' },
  { path: '/rippling' },
  { path: '/circles' },
  { path: '/reports' },
  { path: '/testing' },
  { path: '/signup' },
  { path: '/ask-kula' },
  { path: '/flows' },
  { path: '/login' },
  { path: '/tasks' },
  { path: '/jobs' },
  { path: '/' },
];
